import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { SITE_NAME } from "@/constants/site";

export default function AdminLoginPage() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please fill both fields.");
      return;
    }
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error || "Login failed.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-2xl shadow-[0_30px_60px_-25px_rgba(10,10,10,0.18)] p-8">
        <div className="flex items-center gap-2 mb-6">
          <img src="/bondstein-logo.png" alt="Bondstein" className="h-8 w-auto object-contain" />
          <div>
            <div className="font-display font-bold tracking-tight text-neutral-950 text-sm leading-snug">
              {SITE_NAME}
            </div>
            <div className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-neutral-500">
              Admin sign-in
            </div>
          </div>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4">
          <label className="block">
            <span className="block font-mono-ui text-[10px] uppercase tracking-[0.18em] text-neutral-500 mb-1.5">
              Email
            </span>
            <Input
              data-testid="admin-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@bondstein.com"
              autoFocus
            />
          </label>
          <label className="block">
            <span className="block font-mono-ui text-[10px] uppercase tracking-[0.18em] text-neutral-500 mb-1.5">
              Password
            </span>
            <Input
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </label>
          <Button
            type="submit"
            data-testid="admin-login-submit"
            disabled={submitting}
            className="w-full bg-[#84CC16] text-[#0A0A0A] hover:bg-[#65A30D] font-semibold h-11"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="mt-6 text-xs text-neutral-500 text-center">
          <a href="/" className="hover:text-neutral-900">← Back to site</a>
        </p>
      </div>
    </div>
  );
}
